import { writable } from 'svelte/store';
import { isUserLogged, userInfo, userManager } from './user';
import createConnectedStore from './connectedStore';
import { userClientData } from './client';
import { queryInterestList } from '../graphql/queries/interests';
import { queryAllClients } from '../graphql/queries/clients';
const graphQLErrors = writable([]);
const interests = createConnectedStore(queryInterestList, 'interests');
const availableClients = createConnectedStore(queryAllClients, 'allClients');
export { availableClients, interests, graphQLErrors, isUserLogged, userInfo, userManager, userClientData };
